import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/iconAverage.svg";

export const AvgSvg = styled(svg)`
    padding-top: 4px;
    width: 28px;
    fill: white;
`;